/** @format */

import moment from 'moment';
import {
    PRODUCT_TYPE_CARTON,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_LABEL,
    SHAPE_RECTANGLE,
    SHAPE_SQUARE
} from 'frontier-constants';

const PLACEHOLDER = '—';

export const formatMoney = amount => {
    if (amount == null || isNaN(amount) || amount === Infinity) return PLACEHOLDER;
    return (
        '$' +
        amount.toLocaleString('en-us', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
            //useGrouping: true
        })
    );
};

export const formatNumber = n => {
    n = parseFloat(n);
    if (isNaN(n) || n === Infinity) return PLACEHOLDER;
    return n.toLocaleString();
};

export const formatPercent = n => {
    n = parseFloat(n) * 100;
    if (isNaN(n) || n === Infinity) return PLACEHOLDER;
    return n.toLocaleString() + '%';
};

// Returns e.g. "Jan 7"
export const formatShortDate = date => {
    if (date == null || date === '') return PLACEHOLDER;
    return moment(date).format('MMM D');
};

export const capitalize = s => (s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : '');

// the helpers below were implemented as scope of Cart/ Checkout redesign (2022) to standardize
// all labeling for poducts across our platform

// returns a less crowded label product label in the formats:
// 2.125" x 2.125" Label
// 2.125" x 2.125" x 2.125" Carton
// Custom Design (Label / Carton)
export const prettyProductLabel = (label = '', productTypeId) => {

    label = label.replace('W:', '').replace('L:', '').replace('D:', '');

    const formattingIndex = productTypeId === PRODUCT_TYPE_CARTON ? 7 : 4;
    const cartonLabelLabel = label
        .split(' ')
        .map((w, i) => (i <= formattingIndex ? w : ''))
        .join(' ');

    if (productTypeId === PRODUCT_TYPE_LABEL) return `${cartonLabelLabel} Label`;
    if (productTypeId === PRODUCT_TYPE_CARTON) return `${cartonLabelLabel} Carton`;
    if (productTypeId === PRODUCT_TYPE_GRAPHIC_DESIGN) {
        label = label.split(' - ');
        label = label[0] + ` (${label[1]})`;
        return label;
    }
};

//returns the size of aproduct removing the dimension labels:
// for cartons:  2.55" x 2.55" x 2.55"
// for labels: 0.55" x 055"
export const prettyProductSize = (size, productTypeId, graphcDesignProductId) => {
    size = size.replace('W:', '').replace('L:', '').replace('D:', '');

    if (productTypeId === PRODUCT_TYPE_LABEL || graphcDesignProductId === 1)
        return `${size
            .split(' ')
            .map((s, i) => (i <= 4 && s !== '' ? s : null))
            .join(' ')}`;

    if (productTypeId === PRODUCT_TYPE_CARTON || graphcDesignProductId === 2)
        return `${size
            .split(' ')
            .map((s, i) => (i <= 7 && s !== '' ? s : null))
            .join(' ')}`;
};

// returns the shape for a product in the format:
// Rectangle/ Square (with square/ round corners)
// Oval/ Circle
export const prettyProductShape = (shape_label, is_square_corners, shape_id) => {
    const cornerShape = is_square_corners ? 'squared' : 'round';
    const isSquareOrRectangle = shape_id === SHAPE_SQUARE || shape_id === SHAPE_RECTANGLE;
    if (isSquareOrRectangle) return `${shape_label} (with ${cornerShape} corners)`;
    else if (!isSquareOrRectangle) return shape_label;
};
